import { ITranslationService } from '@/Foundation/Translation/platform/app/translation.service';
import { IStoreSupportFaqItem } from '@gn-audio/core/api/store-support/models/store-support-faq-item';
import { Component, Inject, Input, OnInit } from 'angular-ts-decorators';

import template from './category-faq-item.component.html';

@Component({
  selector: 'categoryFaqItem',
  template,
})

export class CategoryFaqItemComponent implements OnInit {
  
readonly defaultSlideTimeout: number = 250;
  public static $inject: ReadonlyArray<string> = ['$element'];  
  constructor(
    @Inject('$element') private $element: JQLite,
    @Inject('translation') translation: ITranslationService,
  ) 
  { 
  const copyLink = translation.getSystem('CopyLink');

    if(copyLink.length !==0){
    this.copyLink = copyLink;
  }

  const copied = translation.getSystem('Copied');
    if(copied.length !==0){
    this.copied = copied;
    }
  }

  @Input() public item?: IStoreSupportFaqItem;

    public faqItemHash: number;
    public faqItemUrl?: string;    
    public copyLink: string = 'Copy Link';
    public copied: string = 'Copied'; 

  public CopyToClipboard(content: string) {
    navigator.clipboard.writeText(content)
    .then()
    .catch(e => console.error(e));
}

private getHash(str?: string | null): number {
    let hash: number = 0;

    if (str.length === 0) 
    return hash;

    for (let i = 0; i < str.length; i++) {
      const chr = str.charCodeAt(i);
      /* tslint:disable:no-bitwise */
      hash = (hash << 5) - hash + chr;
      hash |= 0;
      /* tslint:enable:no-bitwise */
    }
    return hash;
  };

  private activateByHash() {
    const hash = location.hash;

      if (!hash){
        return;
      }

      const cleanHash = hash.indexOf("/") > -1 ? 
      hash.split("/")[1] : 
      hash.split("#")[1];

      if(cleanHash.length === 0){
          return;
      }

      if(cleanHash === (this.faqItemHash+'')) {
        const $answer: JQuery = this.$element.find('.category-faq-item__answer');

        $answer.show();
        $answer.parent().addClass('active');
      }
  }

public onBtnClick(event) {
  event.stopPropagation();
    this.CopyToClipboard(this.faqItemUrl);

    const $btn: JQuery = this.$element.find('.category-faq-item__copy-url');

    $btn.addClass('active')
    .delay(1500)
    .queue(function(next){
      $(this).removeClass('active');
        next();
    });
}

public onClick() {
    const $answer: JQuery = this.$element.find('.category-faq-item__answer');
    $answer.slideToggle(this.defaultSlideTimeout, ()=> {
      if($answer.css('display') === 'none'){
        $answer.parent().removeClass('active');
      }else{
        $answer.parent().addClass('active');
      }
    });
}

 public ngOnInit() {
    if (!this.item) {
        return;
      }

    this.faqItemHash = this.getHash(this.item?.question);
    this.faqItemUrl = location.origin + location.pathname + `#/${this.faqItemHash}`;
    this.activateByHash();
  }
}
